import { useTranslation } from 'react-i18next';
import { getLocale } from 'utils/helpers/functions/getLocale';

interface DateTimeDisplayProps {
    value: number | Date;
}

const DateTimeDisplay = ({ value }: DateTimeDisplayProps) => {
    const { i18n } = useTranslation();
    const date = value instanceof Date ? value : new Date(value);
    const locale = getLocale(i18n.resolvedLanguage || i18n.language);

    if (Number.isNaN(date.getTime())) return <span className="text-muted">—</span>;

    return (
        <time className="text-end flex-shrink-0" dateTime={date.toISOString()}>
            <span className="d-block fw-medium text-body">
                {date.toLocaleDateString(locale, {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                })}
            </span>
            <span className="d-block small text-muted">
                {date.toLocaleTimeString(locale, {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                })}
            </span>
        </time>
    );
};

export default DateTimeDisplay;
